import { render, staticRenderFns } from "./disassembly-add-or-update.vue?vue&type=template&id=0c8c7783&scoped=true"
import script from "./disassembly-add-or-update.vue?vue&type=script&lang=js"
export * from "./disassembly-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./disassembly-add-or-update.vue?vue&type=style&index=0&id=0c8c7783&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8c7783",
  null
  
)

export default component.exports